var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotemSelect',{ref:"selectContentType",staticClass:"filter-select",attrs:{"options":_vm.contentTypeOptions,"placeholder":_vm.$t('ContentListFilter.content_type')},on:{"input":_vm.selectContentType}})
}
var staticRenderFns = []

export { render, staticRenderFns }